<!--
  @Author 22030124/xieyq
  @Date 2023-12-05 19:26:14
  @Description 门户预览
-->
<template>
  <!-- 渲染 -->
  <workbench-design-render
    :class="scope.clsPrefix"
    ref="workbench"
    v-loading="loading"
    v-if="data"
    :data="data"
   />
</template>

<script>
// 渲染
import WorkbenchDesignRender from '@/components/workbench-design/render/index.vue'
import {
  // 请求工作台详情
  requestDetailWorkbench
} from '@/api/work-bench.js'
import { mapGetters } from 'vuex'
export default {
  // 组件名称
  name: 'WorkbenchRender',
  components: {
    WorkbenchDesignRender
  },
  provide() {
    return {
      // 当前选择的组件
      select: () => { }
    }
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'workbench-render'
      },
      // 是否正在加载
      loading: true,
      // 数据
      data: null
    }
  },
  computed: {
    ...mapGetters(['currentWorkbench']),
    // 工作台id
    workbenchId() {
      return this.currentWorkbench.id
    }
  },
  watch: {
    // 工作台id发生变化，需要重新请求数据
    workbenchId() {
      this.getData()
    }
  },
  // 创建完成
  created() {
    // 调用初始化方法
    this.init()
  },
  // 挂载完成
  mounted() {},
  // 方法
  methods: {

    /**
     * 初始化方法
     * @returns {void}
     */
    init() {
      // 获取数据
      this.getData()
    },
    /**
     * 获取数据
     * @returns {void}
     */
    getData() {
      if (!this.workbenchId) {
        return
      }
      // 开始加载
      this.loading = true
      // 请求工作台详情
      requestDetailWorkbench(this.workbenchId).then(({ data }) => {
        // 停止加载
        this.loading = false
        // 数据赋值
        this.data = {
          id: this.workbenchId,
          // 列数
          colNum: 12,
          // 间距
          margin: [10, 10],
          // 名称
          name: data.workplaceName,
          // 布局的数据
          layout: data.blocks.map(item => {
            return {
              // 组件属性
              i: item.fieldId,
              // 列位置
              x: item.x,
              // 行位置
              y: item.y,
              // 宽度
              w: item.width,
              // 高度
              h: item.height,
              // 数据
              data: {
                ...item,
                // key
                key: item.blockId,
                // 标签
                label: item.name,
                // npm动态加载
                npmDynamic: true,
                // 参数选项
                options: JSON.parse(item.optionValue)
              }
            }
          })
        }
      }).catch(() => {
        // 停止加载
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'workbench-render';
.#{$class-prefix} {
  position: relative;
  height: 100%;
  // overflow: auto;
}
</style>
